import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./press-releases.${locale}.json`));
